import { render, staticRenderFns } from "./OrderDesignate2.vue?vue&type=template&id=1cbe7388&scoped=true"
import script from "./OrderDesignate2.vue?vue&type=script&lang=js"
export * from "./OrderDesignate2.vue?vue&type=script&lang=js"
import style0 from "./OrderDesignate2.vue?vue&type=style&index=0&id=1cbe7388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe7388",
  null
  
)

export default component.exports